import logo from './logo.png'
import add_icon from './add_icon.png'
import order_icon from './order_icon.png'
import upload_area from './upload_area.png'
import parcel_icon from './parcel_icon.svg'


export const assets = {
    logo,
    add_icon,
    order_icon,
    upload_area,
    parcel_icon
}